<!--
 * @Auther: 罗耀祖
 * @Date: 2022-03-17 13:40:12
 * @LastEditors: 罗耀祖
 * @LastEditTime: 2022-08-22 17:37:58
 * @name: 已通过琴行
 * @Description: 已通过琴行
 * @FilePath: \preSaleNafterSaleBackstage\src\components\pianoCompanyManage\company-list.vue
 * @Author: desktop
-->
<template>
  <div>
    <div class="statistics">
      共搜索到 {{ pianoCompany.pianoCompanyTable.total }} 条数据
    </div>
    <table-search-form>
      <template v-slot:searchForm>
        <div class="search-form">
          <div class="search-line">
            <div class="search-label"><font>搜索</font></div>
            <div class="search-content">
              <el-input
                size="mini"
                v-model="searchForm.agency_name"
                placeholder="请输入琴行名称"
                @blur="setFocus()"
                @keyup.native.enter="onQuery"
              ></el-input>
            </div>
          </div>
          <div class="btn-group">
            <el-button
              size="mini"
              icon="el-icon-search"
              type="primary"
              id="filterSearch"
              @keyup.enter="onQuery"
              @click="onQuery"
              >搜索</el-button
            >
          </div>
        </div>
      </template>
      <template v-slot:head>
        <div class="head">
          <el-button size="mini" plain @click="add">添加琴行</el-button>
          <el-button
            size="mini"
            plain
            @click="updateSalerBatch"
            :disabled="selectRow.length === 0"
            >批量更换销售</el-button
          >
          <el-button
            size="mini"
            plain
            @click="updateManagerBatch"
            :disabled="selectRow.length === 0"
            >批量更换经理</el-button
          >
          <el-button size="mini" plain @click="push">导入</el-button>
        </div>
      </template>
      <template v-slot:table>
        <el-table
          :data="pianoCompany.pianoCompanyTable.list"
          v-loading="loading"
          tooltip-effect="light"
          element-loading-text="数据加载中"
          fit
          :header-cell-style="{
            'background-color': $scssVars['Vars-background-bar-normal'],
            color: '#666',
          }"
          :style="{ fontSize: $scssVars['Vars-font-content-size'] }"
          @selection-change="handleSelectionChange"
        >
          <el-table-column type="selection" align="center" width="55">
          </el-table-column>
          <el-table-column type="expand">
            <template slot-scope="props">
              <el-table
                size="mini"
                :data="props.row.agency_user"
                tooltip-effect="light"
                fit
                :header-cell-style="{
                  'background-color': $scssVars['Vars-background-bar-normal'],
                  color: '#666',
                }"
                style="width: calc(100% - 400px)"
                :style="{
                  fontSize: $scssVars['Vars-font-miniContent-size'],
                }"
              >
                <el-table-column
                  align="center"
                  prop="realname"
                  label="人员名称"
                >
                </el-table-column>
                <el-table-column align="center" prop="mobile" label="联系电话">
                </el-table-column>
                <el-table-column
                  align="center"
                  prop="role.role_name"
                  label="角色"
                >
                </el-table-column>
                <el-table-column
                  align="center"
                  fixed="right"
                  label="操作"
                  width="120"
                >
                  <template slot-scope="scope">
                    <el-button
                      size="mini"
                      type="text"
                      @click="editAccount(props.row, scope.row)"
                      >修改</el-button
                    >
                  </template>
                </el-table-column>
              </el-table>
            </template>
          </el-table-column>
          <el-table-column align="left" prop="id" label="ID" width="60">
          </el-table-column>
          <el-table-column
            align="center"
            prop="agency_name"
            label="琴行名称"
            width="180"
          >
          </el-table-column>
          <el-table-column align="center" prop="address" label="地址">
          </el-table-column>
          <el-table-column
            align="center"
            prop="department_user.realname"
            label="跟进销售"
            width="150"
          >
          </el-table-column>
          <el-table-column
            align="center"
            prop="department_manager.realname"
            label="销售经理"
            width="150"
          >
          </el-table-column>
          <!-- <el-table-column
            align="center"
            prop="credit_limit"
            label="额度(元)"
            width="150"
          >
          </el-table-column>
          <el-table-column
            align="center"
            prop="credit_month"
            label="还款周期(月)"
            width="150"
          >
          </el-table-column> -->
          <el-table-column
            align="center"
            fixed="right"
            label="操作"
            width="400"
          >
            <template slot-scope="scope">
              <template v-if="!scope.row.erp_id">
                <el-button size="mini" type="text" @click="bindErp(scope.row)"
                  >绑定ERP</el-button
                ><font class="clip">|</font>
              </template>
              <el-button size="mini" type="text" @click="updateSaler(scope.row)"
                >更换销售</el-button
              ><font class="clip">|</font>
              <el-button
                size="mini"
                type="text"
                @click="updateManager(scope.row)"
                >更换经理</el-button
              ><font class="clip">|</font>
              <el-button
                size="mini"
                type="text"
                @click="editJurisdiction(scope.row)"
                >商品权限</el-button
              >
              <font class="clip">|</font>
              <!-- <el-button size="mini" type="text" @click="editLimit(scope.row)"
                >额度设置</el-button
              >
              <font class="clip">|</font>
              <el-button size="mini" type="text" @click="editCycle(scope.row)"
                >还款周期</el-button
              >
              <font class="clip">|</font> -->
              <el-button size="mini" type="text" @click="delItem(scope.row)"
                >删除</el-button
              >
            </template>
          </el-table-column>
        </el-table>
      </template>
      <template v-slot:pagination>
        <Pagination
          class="pagination"
          :page.sync="pagination.page"
          :page-size.sync="pagination.limit"
          :total="Number(pianoCompany.pianoCompanyTable.total)"
        ></Pagination>
      </template>
    </table-search-form>
    <add-piano-company
      ref="addPianoCompany"
      :pianoCompany="pianoCompany"
      @submit="addPianoCompanyHandler"
    ></add-piano-company>
    <update-saler
      ref="updateSaler"
      :pianoCompany="pianoCompany"
      @updateSaler="updateSalerHandler"
    ></update-saler>
    <update-manager
      ref="updateManager"
      :pianoCompany="pianoCompany"
      @updateManager="updateManagerHandler"
    ></update-manager>
    <push-multiple
      ref="pushMultiple"
      @uploadSuccess="uploadSuccess"
    ></push-multiple>
    <jurisdiction
      ref="jurisdiction"
      @confirm="editJurisdictionHandler"
    ></jurisdiction>
    <edit-limit ref="editLimit" @editLimit="editLimitHandler"></edit-limit>
    <edit-cycle
      ref="editCycle"
      :pianoCompany="pianoCompany"
      @editCycle="editCycleHandler"
    ></edit-cycle>
    <edit-account
      ref="editAccount"
      @editAccount="editAccountHandler"
    ></edit-account>
    <erp-bind ref="erpBind" @confirm="erpBindConfirm"></erp-bind>
  </div>
</template>
<script>
import tableSearchForm from "@/components/public/table-search-form.vue";
import addPianoCompany from "@/components/pianoCompanyManage/dialog/add-piano-company.vue";
import updateSaler from "@/components/pianoCompanyManage/dialog/update-saler.vue";
import updateManager from "@/components/pianoCompanyManage/dialog/update-manager.vue";
import pushMultiple from "@/components/pianoCompanyManage/dialog/push-multiple.vue";
import jurisdiction from "@/components/pianoCompanyManage/dialog/jurisdiction.vue";
import editLimit from "@/components/pianoCompanyManage/dialog/edit-limit.vue";
import editCycle from "@/components/pianoCompanyManage/dialog/edit-cycle.vue";
import editAccount from "@/components/pianoCompanyManage/dialog/edit-account.vue";
import erpBind from "@/components/pianoCompanyManage/dialog/erp-bind.vue";
import { confirmation, debounceation } from "@/utils/decorator";
import { setErpId } from "@/api/pianoCompanyManage/pianoCompanyManage.api";
export default {
  name: "companyList",
  components: {
    tableSearchForm,
    addPianoCompany,
    updateSaler,
    updateManager,
    pushMultiple,
    jurisdiction,
    editLimit,
    editCycle,
    editAccount,
    erpBind,
  },
  props: {
    pianoCompany: {
      type: Object,
    },
  },
  data() {
    return {
      status: 1,
      selectRow: [], //选择行
      searchForm: {
        agency_name: "",
      }, //搜索条件
      loading: false, //表格加载状态
      pagination: {
        //分页信息
        page: 1,
        limit: 10,
      },
    };
  },
  watch: {
    pagination: {
      handler(nv, ov) {
        nv.page && this.getTable();
      },
      immediate: true,
      deep: true,
    },
  },
  methods: {
    /**
     * @Auther: 罗耀祖
     * @LastEditors: 罗耀祖
     * @description: 初始化分页信息
     */
    initPagination() {
      this.pagination = {
        page: 1,
        limit: 10,
      };
    },
    /**
     * @Auther: 罗耀祖
     * @LastEditors: 罗耀祖
     * @description: 置焦点于搜索框
     */
    setFocus() {
      document.getElementById("filterSearch").focus();
    },
    /**
     * @Auther: 罗耀祖
     * @LastEditors: 罗耀祖
     * @description: 点击搜索框
     */
    @debounceation(300)
    onQuery() {
      this.initPagination();
    },
    /**
     * @Auther: 罗耀祖
     * @LastEditors: 罗耀祖
     * @description: 获取表格数据
     */
    getTable() {
      this.loading = true;
      this.pianoCompany
        .getPianoCompanyTable({
          status: this.status,
          ...this.pagination,
          agency_name: this.searchForm.agency_name,
        })
        .finally(() => {
          this.loading = false;
        });
    },
    /**
     * @Auther: 罗耀祖
     * @LastEditors: 罗耀祖
     * @description: 点击添加琴行
     */
    @debounceation(300)
    add() {
      this.$refs.addPianoCompany.open();
    },
    /**
     * @Auther: 罗耀祖
     * @LastEditors: 罗耀祖
     * @description: 添加琴行弹窗回传
     * @param {Object} obj 回传数据
     */
    addPianoCompanyHandler(obj) {
      this.pianoCompany.addPianoCompany(obj).then((res) => {
        this.getTable();
        this.$refs.addPianoCompany.cancel();
      });
    },
    /**
     * @Auther: 罗耀祖
     * @LastEditors: 罗耀祖
     * @description: 选择表格行
     * @param {Array} e 选中的行数据
     */
    handleSelectionChange(e) {
      this.selectRow = e.map((x) => x.id);
    },
    /**
     * @Auther: 罗耀祖
     * @LastEditors: 罗耀祖
     * @description: 点击批量更换销售
     */
    @debounceation(300)
    updateSalerBatch() {
      this.$refs.updateSaler.open(this.selectRow);
    },
    /**
     * @Auther: 罗耀祖
     * @LastEditors: 罗耀祖
     * @description: 更换销售弹窗回传
     * @param {Object} obj 回传数据
     */
    updateSalerHandler(obj) {
      this.pianoCompany
        .updateSaler({
          agency_ids: obj.selectRow,
          belong_user_id: obj.saler_id,
          belong_muser_id: "",
        })
        .then((res) => {
          this.getTable();
          this.$refs.updateSaler.cancel();
        });
    },
    /**
     * @Auther: 罗耀祖
     * @LastEditors: 罗耀祖
     * @description: 点击批量更换经理
     */
    @debounceation(300)
    updateManagerBatch() {
      this.$refs.updateManager.open(this.selectRow);
    },
    /**
     * @Auther: 罗耀祖
     * @LastEditors: 罗耀祖
     * @description: 更换经理弹窗回传
     * @param {Object} obj 回传数据
     */
    updateManagerHandler(obj) {
      this.pianoCompany
        .updateManager({
          agency_ids: obj.selectRow,
          belong_user_id: "",
          belong_muser_id: obj.manager_id,
        })
        .then((res) => {
          this.getTable();
          this.$refs.updateManager.cancel();
        });
    },
    /**
     * @Auther: 罗耀祖
     * @LastEditors: 罗耀祖
     * @description: 点击导入
     */
    @debounceation(300)
    push() {
      this.$refs.pushMultiple.open();
    },
    /**
     * @Auther: 罗耀祖
     * @LastEditors: 罗耀祖
     * @description: 导入成功
     */
    uploadSuccess() {
      this.getTable();
    },
    /**
     * @Auther: 罗耀祖
     * @LastEditors: 罗耀祖
     * @description: 点击更换销售
     * @param {Array} row 表格行数据
     */
    @debounceation(300)
    updateSaler(row) {
      let arr = row?.id ? [row.id] : [];
      this.$refs.updateSaler.open(arr);
    },
    /**
     * @Auther: 罗耀祖
     * @LastEditors: 罗耀祖
     * @description: 点击更换经理
     * @param {Array} row 表格行数据
     */
    @debounceation(300)
    updateManager(row) {
      let arr = row?.id ? [row.id] : [];
      this.$refs.updateManager.open(arr);
    },
    /**
     * @Auther: 罗耀祖
     * @LastEditors: 罗耀祖
     * @description: 点击商品权限
     * @param {Array} row 表格行数据
     */
    @debounceation(300)
    editJurisdiction(row) {
      this.$refs.jurisdiction.open(row.id);
    },
    /**
     * @Auther: 罗耀祖
     * @LastEditors: 罗耀祖
     * @description: 商品权限弹窗回传
     * @param {Object} obj 回传数据
     */
    editJurisdictionHandler(obj) {
      this.pianoCompany.editJurisdiction(obj).then((res) => {
        this.$refs.jurisdiction.cancel();
      });
    },
    /**
     * @Auther: 罗耀祖
     * @LastEditors: 罗耀祖
     * @description: 点击额度设置
     * @param {Array} row 表格行数据
     */
    @debounceation(300)
    editLimit(row) {
      this.$refs.editLimit.open(row);
    },
    /**
     * @Auther: 罗耀祖
     * @LastEditors: 罗耀祖
     * @description: 额度设置弹窗回传
     * @param {Object} obj 回传数据
     */
    editLimitHandler(obj) {
      this.pianoCompany
        .editLimit({
          agency_id: obj.id,
          credit_limit: obj.form.limit,
          credit_month: "",
        })
        .then((res) => {
          this.getTable();
          this.$refs.editLimit.cancel();
        });
    },
    /**
     * @Auther: 罗耀祖
     * @LastEditors: 罗耀祖
     * @description: 点击还款周期
     * @param {Array} row 表格行数据
     */
    @debounceation(300)
    editCycle(row) {
      this.$refs.editCycle.open(row);
    },
    /**
     * @Auther: 罗耀祖
     * @LastEditors: 罗耀祖
     * @description: 还款周期弹窗回传
     * @param {Object} obj 回传数据
     */
    editCycleHandler(obj) {
      this.pianoCompany
        .editCycle({
          agency_id: obj.id,
          credit_limit: "",
          credit_month: obj.form.cycle,
        })
        .then((res) => {
          this.getTable();
          this.$refs.editCycle.cancel();
        });
    },
    /**
     * @Auther: 罗耀祖
     * @LastEditors: 罗耀祖
     * @description: 琴行表格点击删除
     * @param {Array} row 表格行数据
     */
    @confirmation("确认删除该琴行?")
    delItem(row) {
      let { id } = row;
      this.pianoCompany.delPianoCompany({ agency_id: id }).then((res) => {
        this.$message.success("删除成功");
        this.getTable();
      });
    },
    /**
     * @Auther: 罗耀祖
     * @LastEditors: 罗耀祖
     * @description: 子表点击修改
     * @param {Object} row 琴行表格行数据
     * @param {Object} childRow 子表行数据
     */
    @debounceation(300)
    editAccount(row, childRow) {
      this.$refs.editAccount.open(childRow);
    },
    /**
     * @Auther: 罗耀祖
     * @LastEditors: 罗耀祖
     * @description: 修改账号弹窗回传
     * @param {Object} obj 回传数据
     */
    editAccountHandler(obj) {
      this.pianoCompany
        .editAccount({
          id: obj.id,
          realname: obj.form?.realname ?? "",
          mobile: obj.form?.mobile ?? "",
        })
        .then((res) => {
          this.getTable();
          this.$refs.editAccount.cancel();
        });
    },
    /**
     * @Auther: 罗耀祖
     * @LastEditors: 罗耀祖
     * @description: 绑定erp
     */
    @debounceation(300)
    bindErp(row) {
      this.$refs.erpBind.open(row);
    },
    /**
     * @Auther: 罗耀祖
     * @LastEditors: 罗耀祖
     * @description: erp绑定确认
     */
    erpBindConfirm(e) {
      setErpId({
        agency_id: e?.agency_id ?? "",
        erp_id: e.erp?.id ?? "",
      }).then((res) => {
        this.$message.success("绑定成功!");
        this.getTable();
        this.$refs.erpBind.cancel();
      });
    },
  },
};
</script>
<style lang="scss" scoped>
.statistics {
  padding: 10px 0;
  font-size: $Vars-font-miniContent-size;
  color: $Vars-font-secondary-color;
}
.el-table {
  .el-button {
    margin: 0;
    padding: 0 6px;
  }
  .clip {
    color: $Vars-font-placeholder-color;
  }
  /deep/ .el-table__expand-icon {
    .el-icon {
      margin-left: 0;
      margin-top: 0;
      transform: translate(-50%, -50%);
    }
  }
  /deep/ .el-icon-arrow-right:before {
    border: 1px solid $Vars-font-placeholder-color;
    border-radius: $Vars-border-radius-mini;
    color: $Vars-font-placeholder-color;
    padding: 1px;
    content: "\e6d9";
  }
  /deep/ .el-table__expand-icon--expanded {
    transform: rotate(0);
    .el-icon-arrow-right:before {
      content: "\e6d8" !important;
    }
  }
  /deep/ .el-table__fixed-right::before,
  .el-table__fixed::before {
    height: 0 !important;
  }
}
</style>